<template>
  <div name="modal">
    <div
      id="modal_pool"
      class="modal_mask"
      @click="closeModalWarnWithdraw()"
    ></div>
    <div class="modal_wrapper">
      <div class="modal_container">
        <div class="modal_header">
          <h1>{{ $t("msg.modalWarnUser.title") }}</h1>

          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
            @click="closeModalWarnWithdraw()"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </div>

        <div class="modal_content">
          <div class="items">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M5 13l4 4L19 7"
              />
            </svg>
            <span
              style="text-align: start"
              v-html="$t('msg.modalWarnUser.warn1')"
            ></span>
          </div>

          <div class="items">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M5 13l4 4L19 7"
              />
            </svg>
            <span
              style="text-align: start"
              v-html="$t('msg.modalWarnUser.warn2')"
            ></span>
          </div>

          <div class="items">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M5 13l4 4L19 7"
              />
            </svg>
            <span
              style="text-align: start"
              v-html="$t('msg.modalWarnUser.warn3')"
            ></span>
          </div>

          <div class="items">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M5 13l4 4L19 7"
              />
            </svg>
            <span
              style="text-align: start"
              v-html="$t('msg.modalWarnUser.warn4')"
            ></span>
          </div>

          <button @click="understandWarnWithdraw()">
            {{ $t("msg.i_understand") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    this.getMember();
  },
  data: () => ({}),
  methods: {
    closeModalWarnWithdraw() {
      this.$emit("closeModalWarnWithdraw");
    },

    understandWarnWithdraw() {
      this.$emit("understandWarnWithdraw");
    },
  },
};
</script>

<style lang="scss" scope>
.modal_mask {
  position: absolute;
  background-color: rgba(0, 0, 0, 0.6);
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 998;
  overflow: auto;
}

.modal_wrapper {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  margin: 0px auto;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 450px;
  width: 100%;

  .modal_container {
    width: 100%;
    max-width: 450px;
    margin: 0px auto;
    background-color: #fff;
    border-radius: 8px;

    .modal_header {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 1rem 10px;
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
      border-bottom: 1px solid #342365;

      h1 {
        color: #342365;
        font-weight: 600;
        font-size: 1.2rem;
      }

      svg {
        width: 1.5rem;
        position: absolute;
        right: 1rem;
        cursor: pointer;
        color: #342365;
      }
    }

    .modal_content {
      display: flex;
      align-items: start;
      justify-content: center;
      flex-direction: column;
      color: #000;
      padding: 1rem 2rem;

      .items {
        display: grid;
        grid-template-columns: 1fr 10fr;
        padding-bottom: 1rem;
        width: 100%;

        svg {
          margin-top: 5px;
          width: 1.2rem;
          height: 1.2rem;
        }

        span {
          font-size: 14px;
        }
      }

      button {
        flex: 1;
        outline: none;
        background: #342365;
        color: #fff;
        padding: 10px 15px;
        border-radius: 6px;
        border: none;
        width: 100%;
      }
    }

    @media only screen and (max-width: 400px) {
      max-width: 350px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/modals/modalWarnWithdraw.vue